import { RumErrorEvent, RumEvent } from '@datadog/browser-rum';
import { isLocalEnvironment } from '@cko/dashboard-shared';

import { matchMfesFromStackTrace } from './stackTrace';
import { getErrorOrigin } from './origin';
import { ErrorContext, ErrorOrigin } from './types';

const enrichErrorEvent = (event: RumErrorEvent) => {
  const stackTrace = event.error?.stack ?? '';
  const handlingStackTrace = event.error?.handling_stack ?? '';
  const combinedStackTrace = [stackTrace, handlingStackTrace].join('\n') || undefined;

  const mfeProvidedInLog = typeof event.context?.mfe === 'string' ? event.context.mfe : undefined;

  const errorOrigin = mfeProvidedInLog
    ? ErrorOrigin.MICRO_FRONTEND
    : getErrorOrigin(combinedStackTrace);

  const mfeConfigs = window.__app_config.WEBUI_MICROFRONTENDS;
  const mfeName = mfeProvidedInLog || matchMfesFromStackTrace(combinedStackTrace, mfeConfigs)[0];

  const mfeVersion = window.__app_config.WEBUI_MFE_VERSIONS?.[mfeName];

  const errorContext: ErrorContext = {
    error_origin: errorOrigin,
    mfe: mfeName,
    ...(mfeVersion && { version: mfeVersion }),
  };

  event.context = {
    ...event.context,
    ...errorContext,
  };
};

const shouldSendEvent = (event: RumEvent) => {
  if (isLocalEnvironment()) {
    return false;
  }

  if (event.type !== 'error') {
    return true;
  }

  enrichErrorEvent(event);

  return true;
};

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

export const beforeSend = (event: RumEvent) => {
  try {
    return shouldSendEvent(event);
  } catch (error) {
    if (isObject(event.context)) {
      event.context = {
        ...event.context,
        enriched: 'failed',
      };
    }

    return true;
  }
};
